import React from 'react';
import { StyleSheet, View, ScrollView } from 'react-native';
import PropTypes from 'prop-types';
import Text from '@/components/Typography/Text';
import PublicFooter from '@/components/PublicFooter';
import useResponsiveness from '@/hooks/useResponsiveness';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollView: {
    flexGrow: 1,
  },
  contentWrapper: {
    width: '100%',
    maxWidth: 600,
    padding: 20,
    paddingTop: 100,
    paddingBottom: 60,
    alignItems: 'center',
  },
  header: {
    alignItems: 'center',
    marginBottom: 40,
  },
  title: {
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'center',
    lineHeight: 28,
    maxWidth: 600,
    marginBottom: 8,
  },
});

const PublicPage = ({
  title,
  subtitle,
  children,
  maxContentWidth = 600,
  showHeader = true,
  scrollable = true,
}) => {
  const { showsScrollIndicator } = useResponsiveness();

  const content = (
    <>
      <View style={[styles.contentWrapper, { maxWidth: maxContentWidth }]}>
        {showHeader && (
          <View style={styles.header}>
            <Text style={styles.title} size='xxxl' color='primary'>{title}</Text>
            {subtitle && (
              <Text style={styles.subtitle} size='m' color='secondary'>
                {subtitle}
              </Text>
            )}
          </View>
        )}
        {children}
      </View>
      <PublicFooter />
    </>
  );

  if (!scrollable) {
    return (
      <View style={styles.container}>
        {content}
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={{ alignItems: 'center' }}
        showsVerticalScrollIndicator={showsScrollIndicator}
      >
        {content}
      </ScrollView>
    </View>
  );
};

PublicPage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  maxContentWidth: PropTypes.number,
  showHeader: PropTypes.bool,
  scrollable: PropTypes.bool,
};

export default React.memo(PublicPage);
